import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ReCAPTCHA from "react-google-recaptcha";
import './style.css';

const ContactForm = () => {
    const { t } = useTranslation();
    const [status, setStatus] = useState("");
    const [recaptchaValue, setRecaptchaValue] = useState(null);
    const navigate = useNavigate();

    const handleRecaptchaChange = (value) => {
        setRecaptchaValue(value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!recaptchaValue) {
            setStatus(t("contact_form.recaptcha_error"));
            return;
        }

        setStatus(t("contact_form.sending"));

        const formData = new FormData(e.target);

        try {
            const recaptchaResponse = await fetch('/recaptcha-verify.php', {
                method: 'POST',
                body: new URLSearchParams({ 'g-recaptcha-response': recaptchaValue }),
            });

            const recaptchaResult = await recaptchaResponse.json();

            if (!recaptchaResult.success) {
                setStatus(t("contact_form.recaptcha_error"));
                return;
            }

            const response = await fetch("https://formspree.io/f/xjkybbng", {
                method: "POST",
                headers: {
                    "Accept": "application/json",
                },
                body: formData,
            });

            if (response.ok) {
                navigate("/thank");
            } else {
                setStatus(t("contact_form.error"));
            }
        } catch (error) {
            console.error("Fetch error:", error);
            setStatus(t("contact_form.server_error"));
        }
    };

    return (
        <form onSubmit={handleSubmit} className="custom__form" method="POST">
            <input type="hidden" name="_subject" value={t("contact_form.subject")} />
            <h1 className="form__title">{t("contact_form.title")}</h1>
            <div className="form__subtitle">{t("contact_form.subtitle")}</div>

            <label htmlFor="nimi">{t("contact_form.name")}<span>*</span></label>
            <input className="input__form" type="text" placeholder={t("contact_form.name_placeholder")} name="nimi" id="nimi" required />
            
            <label htmlFor="phone">{t("contact_form.phone")}<span>*</span></label>
            <input className="input__form" type="text" placeholder={t("contact_form.phone_placeholder")} name="phone" id="phone" required />

            <label htmlFor="email">{t("contact_form.email")}</label>
            <input className="input__form" type="email" placeholder={t("contact_form.email_placeholder")} name="email" id="email" required />

            <h2 className="subtitle">{t("contact_form.topic")}</h2>

            <label className="checkbox__row">
                <input name="lisatietoja" className="real__checkbox" type="checkbox" />
                <span className="custom__checkbox"></span>
                <span>{t("contact_form.product_info")}</span>
            </label>

            <label className="checkbox__row">
                <input name="hinta" className="real__checkbox" type="checkbox" />
                <span className="custom__checkbox"></span>
                <span>{t("contact_form.price_info")}</span>
            </label>

            <label className="checkbox__row">
                <input name="muuta_asiaa" className="real__checkbox" type="checkbox" />
                <span className="custom__checkbox"></span>
                <span>{t("contact_form.other")}</span>
            </label>

            <label htmlFor="info">{t("contact_form.help_text")}</label>
            <textarea className="info" name="info" id="info" maxLength="180"></textarea>

            <ReCAPTCHA sitekey="6LcFj-oqAAAAAMXpLShN-_uNQkBKxuEQENONP77g" 
            onChange={handleRecaptchaChange}
            hl="fi" />

            <button type="submit" className="btn__submit btn">{t("contact_form.submit")}</button>
            <p>{status}</p>
        </form>
    );
};

export default ContactForm;
